import { Button } from '@cibli/shared';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface FormLayoutProps {
  title: string;
  children: React.ReactNode;
  onCancel: () => void;
  onSubmit: () => void;
  showAddButton?: boolean;
  onAdd?: () => void;
  addButtonText?: string;
  isAddDisabled?: boolean;
}

const FormLayout: React.FC<FormLayoutProps> = ({
  title,
  children,
  onCancel,
  onSubmit,
  showAddButton = false,
  onAdd,
  addButtonText,
  isAddDisabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto p-4 max-w-2xl">
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-2 w-full items-center mb-4">
            <h3 className="text-lg text-primary">{t('Forms.title')}</h3>
            <h1 className="text-2xl font-bold">{title}</h1>
          </div>
        </div>

        {children}

        {showAddButton && onAdd && (
          <div className="flex justify-center">
            <Button
              type="button"
              onClick={onAdd}
              disabled={isAddDisabled}
              className="bg-primary text-white hover:bg-primary/90"
            >
              {addButtonText}
            </Button>
          </div>
        )}

        <div className="flex justify-between gap-4 mt-6">
          <Button type="button" size="lg" variant="secondary" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button
            type="button"
            size="lg"
            className="bg-primary text-white hover:bg-primary/90"
            onClick={onSubmit}
          >
            {t('common.save')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FormLayout;
